import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'paginator-dot',
    templateUrl: './pagination-dot.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaginationDotComponent implements OnInit {
  @Input() pages?: any;
  activeIndex: any;
  constructor() {}

  ngOnInit() {
    this.activeIndex = 1;
  }
  goToPage(index: number) {
    this.activeIndex = index;
  }
}
